const helpers = {
  elExists: (arr) => {
    let isExist = false;
    arr.forEach(el => {
      if (document.querySelectorAll(el).length) {
        isExist = true;
      }
    });
    return isExist;
  },
  elExist: (id) => {
    return document.getElementById(id) != null ? true : false;
  },
  addScript: (url) => {
    let scriptEl = document.createElement('script');
    scriptEl.src = url;
    document.body.appendChild(scriptEl);
  },
  removeCurrentClass: (arr) => {
    arr.forEach(element => {
      element.classList.remove('current');
    });
  },
  showWhenScroll: function(el, offsetY) {
    if (el) {
      if (window.pageYOffset > offsetY) {
        el.classList.add('show');
      } else {
        el.classList.remove('show');
      }
    }
  },
  formatCurrency: function(n, currency) {
    return parseInt(n).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + currency;
  },
  addCss: function(href) {
    let headEl = document.getElementsByTagName('head')[0],
      linkEls = headEl.querySelectorAll('link');
    linkEls.forEach(linkEl => {
      if (linkEl.href.search('/assets/css/style.min.css') > 0) {
        let linkNewEl = document.createElement('link');
        linkNewEl.rel = 'stylesheet';
        linkNewEl.type = 'text/css';
        linkNewEl.href = href;
        linkNewEl.media = 'all';
        headEl.insertBefore(linkNewEl, linkEl);
      }
    });
  }
};

export default helpers;